import React from 'react';
import { useHistory } from 'react-router-dom';
import { useRedesign } from '../../Components/general/RedesignShell';

export const VCIntroPage: React.FC = () => {
  const history = useHistory();
  const { openModal } = useRedesign();

  return (
    <>
      <h1>數位憑證</h1>
      <p className="dc-lead">從學位憑證領取到驗證，選擇適合您的服務。</p>

      <div className="dc-grid">
        <article className="dc-service feature">
          <span className="dc-number">01 / VC APPLICATION</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            <h2>憑證申請</h2>
          </div>
          <p>將數位證書轉為可存入手機皮夾的憑證。</p>
          <button
            type="button"
            className="dc-button primary"
            onClick={() => history.push('/vc/apply')}
          >
            開始申請
          </button>
        </article>

        <article className="dc-service">
          <span className="dc-number">02 / VC VERIFICATION</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            <h2>憑證驗證</h2>
            <span
              className="dc-label"
              style={{ color: 'var(--dc-gold)', borderColor: 'var(--dc-gold)' }}
            >
              開發中，即將推出
            </span>
          </div>
          <p>了解查驗方式，確認憑證資料。</p>
          <button
            type="button"
            className="dc-button"
            onClick={() => openModal('憑證驗證功能開發中', '此功能仍在開發中，敬請期待！')}
          >
            查看憑證驗證
          </button>
        </article>
      </div>

      <div className="dc-actions" style={{ marginTop: '28px' }}>
        <button
          type="button"
          className="dc-button"
          onClick={() => history.push('/vc/help')}
        >
          查看使用說明
        </button>
      </div>
    </>
  );
};

export default VCIntroPage;
